<template>
  <svg
    width="15"
    height="9"
    viewBox="0 0 15 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.9147 8.66685L0.239632 1.99166C0.0851213 1.83727 0 1.63118 0 1.41142C0 1.19167 0.0851213 0.985572 0.239632 0.831183L0.731092 0.339602C1.05133 0.0197263 1.57182 0.0197263 1.89157 0.339602L7.49689 5.94492L13.1084 0.333382C13.2629 0.178993 13.4689 0.09375 13.6885 0.09375C13.9084 0.09375 14.1144 0.178993 14.269 0.333382L14.7604 0.824964C14.9149 0.979475 15 1.18545 15 1.4052C15 1.62496 14.9149 1.83105 14.7604 1.98544L8.0792 8.66685C7.9242 8.82161 7.71725 8.90661 7.49726 8.90612C7.2764 8.90661 7.06958 8.82161 6.9147 8.66685Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'SvgVectorDown',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>

<style>

</style>
